import { CapoPlugin } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];